<template>
  <div class="mb-4">
    <TextLabel v-if="textLabel" v-bind="textLabel" class="d-block mb-0" />
    <TextBlock v-if="textBlock" v-bind="textBlock" />
  </div>
</template>

<script>
import TextLabel from '@/components/atoms/TextLabel';
import TextBlock from '@/components/atoms/TextBlock';
import { emptyObject } from '@/utils/factories';

export default {
  name: 'TextBlockWithLabel',
  components: {
    TextBlock,
    TextLabel,
  },
  props: {
    textLabel: {
      type: Object,
      default: emptyObject(),
    },
    textBlock: {
      type: Object,
      default: emptyObject(),
    },
  },
};
</script>
